import { Link } from '@coolblue-development/freddy';
import clickAllTrigger from '@coolblue-development/ga4-events/triggers/ProductSpecifications/clickAllTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { scrollToTarget } from '@utils/utils';

type FullSpecificationsLinkProps = {
  onMobileClick: () => void;
  children: React.ReactNode;
  isComposed?: boolean;
};

export default function FullSpecificationsLink({
  children,
  onMobileClick,
  isComposed
}: FullSpecificationsLinkProps) {
  const { isMobile } = useBreakpoints();
  const { trackEvent } = useAnalytics();

  const onClick = (
    event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
  ): void => {
    trackClick();

    if (isMobile) {
      onMobileClick();

      return;
    }

    scrollToTarget('product-specifications')(
      event as React.MouseEvent<HTMLAnchorElement, MouseEvent>
    );
  };

  function trackClick() {
    if (isComposed) {
      trackEvent(clickAllTrigger({ sub_feature: 'composed_content' }));
      return;
    }

    trackEvent(
      clickAllTrigger({
        sub_feature: 'short_specifications'
      })
    );
  }

  const commonProps = { mt: 200, onClick, startIcon: <ArrowRight /> };

  if (isMobile) {
    return (
      <Link {...commonProps} component='button'>
        {children}
      </Link>
    );
  }

  return (
    <Link {...commonProps} component='a' href='#product-specifications'>
      {children}
    </Link>
  );
}
